import { contentsRefusalSpent, type ContentsRefusal } from "@baluu/ui/lib/checkout/basket-contents-refusal";

/**
 * What the error slot shows (pure, for the tests). The overlay keeps the last
 * press's refusal of the basket's contents (@baluu/ui `contentsRefusalFor`)
 * beside its `error` string rather than in it, which the availability
 * retraction and the form checks write as plain text. The refusal offers its
 * fix (`basketFix`) while it is the message on screen (any later `setError`
 * replaced it) and hasn't been spent; a spent one isn't shown.
 */
export function errorSlotFor(
  error: string | null,
  refusal: ContentsRefusal | null,
  items: ReadonlyArray<{ id: string }>,
): { error: string | null; basketFix: boolean } {
  if (!error || !refusal || refusal.message !== error) return { error, basketFix: false };
  return contentsRefusalSpent(refusal, items)
    ? { error: null, basketFix: false }
    : { error, basketFix: true };
}
